import i18n from '@agentguru/i18n';
import languages from './messages';
Object.keys(languages).forEach(function (lang) {
    i18n.addResourceBundle(lang, 'translation', languages[lang].translation);
});
